import React from 'react';
import _ from 'underscore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';

import FsdsaiPersonalized from '../../components/Programs/FsdsaiPersonalized';
import FswdPersonalized from '../../components/Programs/FswdPersonalized';
import FewdPersonalized from '../../components/Programs/FewdPersonalized';
import BewdPersonalized from '../../components/Programs/BewdPersonalized';
import FsdsaiImmersive from '../../components/Programs/FsdsaiImmersive';
import FswdImmersive from '../../components/Programs/FswdImmersive';
import FewdImmersive from '../../components/Programs/FewdImmersive';
import BewdImmersive from '../../components/Programs/BewdImmersive';

import './Info.scss';

class Info extends React.Component {
  render() {
    const selection = this.props.selection;
    if (!selection) { return null; }

    const option = _.find(selection.relationships.price_options.data, option => option.attributes.name === this.props.selectedProgram);
    const immersivePrice = _.find(selection.relationships.price_options.data, option => option.attributes.name === 'immersive');
    const personalizedPrice = _.find(selection.relationships.price_options.data, option => option.attributes.name === 'personalized');

    const { long_symbol } = selection.attributes;

    const propsForProgram = {
      immersivePrice: immersivePrice,
      personalizedPrice: personalizedPrice,
      numOfAssignments: selection.attributes.num_of_assignments,
      numOfHours: selection.attributes.num_of_hours,
      numOfMentorshipMinutes: selection.attributes.num_of_mentorship_minutes
    };

    return (
      <div className="py-3" id="info">
        <div className="d-flex flex-row align-items-center px-2">
          <div className='nmLogo' style={{ backgroundColor: selection.attributes.color, color: 'white' }}>
            {selection.attributes.short_symbol}
          </div>

          <h5 className="m-0 py-0 px-2">{selection.attributes.long_name}</h5>
        </div>

        <div className="p-2" style={{fontSize: "14px"}}>
          <b>{option.attributes.name == 'immersive' ? 'Immersive Path' : 'Personalized Career Path'}</b>

          <div className='my-2 border-bottom' />

          {(long_symbol === 'fsdsai' && option.attributes.name == 'personalized') && <FsdsaiPersonalized
            {...propsForProgram}
          />}
          {(long_symbol === 'fswd' && option.attributes.name == 'personalized') && <FswdPersonalized
            {...propsForProgram}
            hideUpsell={true}
          />}
          {(long_symbol === 'fewd' && option.attributes.name == 'personalized') && <FewdPersonalized
            {...propsForProgram}
            hideUpsell={true}
          />}
          {(long_symbol === 'bewd' && option.attributes.name == 'personalized') && <BewdPersonalized
            {...propsForProgram}
            hideUpsell={true}
          />}

          {(long_symbol === 'fsdsai' && option.attributes.name == 'immersive') && <FsdsaiImmersive
            {...propsForProgram}
          />}
          {(long_symbol === 'fswd' && option.attributes.name == 'immersive') && <FswdImmersive
            {...propsForProgram}
          />}
          {(long_symbol === 'fewd' && option.attributes.name == 'immersive') && <FewdImmersive
            {...propsForProgram}
          />}
          {(long_symbol === 'bewd' && option.attributes.name == 'immersive') && <BewdImmersive
            {...propsForProgram}
          />}
        </div>

        <ReactTooltip place="top" className="solidToolTip p-3 rounded" id="DatesAndTuition" />
      </div>
    );
  }
}

export default Info;
